<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const definitionListVariants = cva('', {
  variants: {
    variant: {
      list: 'flex flex-col',
      grid: 'flex flex-wrap gap-x-5',
      columns: 'flex flex-wrap justify-between gap-x-7'
    },
    size: {
      sm: 'gap-y-1',
      md: 'gap-y-3'
    }
  },
  defaultVariants: {
    variant: 'list',
    size: 'sm'
  }
})

type DefinitionListProps = VariantProps<typeof definitionListVariants>

withDefaults(
  defineProps<{
    twClass?: string,
    variant?: DefinitionListProps['variant'],
    size?: DefinitionListProps['size']
  }>(),
  {
    twClass: '',
    variant: 'list',
    size: 'sm'
  }
)
</script>

<template>
  <div :class="classMerge(definitionListVariants({ variant, size }), twClass)">
    <slot />
  </div>
</template>
